/**
 * 权限判断工具函数
 */
import { authStore } from "@/store/auth";

/**
 * 判断当前用户是否有某个菜单权限
 * @param {string} path — 菜单路径，如 "/order/ltv-v2"
 */
export function hasMenu(path) {
  const perms = authStore.role.value?.menuPermissions;
  if (!perms) return false;
  return perms.includes(path);
}

/**
 * 判断当前用户是否有某个按钮权限
 * @param {string} code — 按钮编码，如 "ltv-v2:upload"
 */
export function hasButton(code) {
  const perms = authStore.role.value?.buttonPermissions;
  if (!perms) return false;
  return perms.includes(code);
}

/**
 * 判断当前用户是否为管理员
 */
export function isAdmin() {
  return authStore.role.value?.code === "admin";
}

/**
 * 获取当前用户可见的维度 ID 列表
 * @returns {number[]} 空数组表示可见全部
 */
export function getAllowedDimensionIds() {
  return authStore.role.value?.dimensionIds || [];
}
